import { useMemo } from 'react';
import { ServiceTypeEnum } from '@/app/store/api/restApi';
import { CustomerTabsEnum, useAppSelector } from '@/app/store';

export const useGetLocationId = () => {
  const selectedCustomerTab = useAppSelector((state) => state.orderAnotherPerson.selectedCustomerTab);
  const {
    deliveryType,
    delivery: myDelivery,
    takeoutAddress: myTakeoutAddress,
    orderPointDelivery: myOrderPointDelivery,
  } = useAppSelector((state) => state.order);
  const {
    delivery: anotherDelivery,
    takeoutAddress: anotherTakeoutAddress,
    orderPointDelivery: anotherOrderPointDelivery,
  } = useAppSelector((state) => state.orderAnotherPerson);

  const isAnotherPersonOrder = selectedCustomerTab === CustomerTabsEnum.Another;
  const delivery = isAnotherPersonOrder ? anotherDelivery : myDelivery;
  const takeoutAddress = isAnotherPersonOrder ? anotherTakeoutAddress : myTakeoutAddress;
  const orderPointDelivery = isAnotherPersonOrder ? anotherOrderPointDelivery : myOrderPointDelivery;

  return useMemo(() => {
    if (deliveryType === ServiceTypeEnum.Takeout) return takeoutAddress;
    if (deliveryType === ServiceTypeEnum.OrderPoint) return orderPointDelivery.locationId;
    if (deliveryType === ServiceTypeEnum.Delivery) return delivery.locationId ?? delivery.nationwideInfo?.locationId;

    return undefined;
  }, [delivery, deliveryType, orderPointDelivery, takeoutAddress]);
};
